import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import type { HttpResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import type { RecordingFilterDTO } from './model/recording-filter.dto';
import type { PlaybackFrameDTO } from './model/playback-frame.dto';
import type { TesterResult } from './model/tester-result.dto';
import type { ParticipantTrendDTO } from '../staff-monitor/model/participant-trend.dto';

@Injectable()
export class RecordingService {
  private readonly apiUrl = environment.apiUrl;
  private readonly http = inject(HttpClient);

  get(recordingId: string, filter: RecordingFilterDTO): Observable<PlaybackFrameDTO[]> {
    return this.http.post<PlaybackFrameDTO[]>(`${this.apiUrl}/recordings/${recordingId}/playback/`, filter);
  }

  getTrend(recordingId: string, mindDeviceId: string): Observable<ParticipantTrendDTO> {
    return this.http.get<ParticipantTrendDTO>(
      `${this.apiUrl}/recordings/${recordingId}/participant/${mindDeviceId}/trend`,
    );
  }

  getTesterResults(recordingId: string, deviceId: string): Observable<TesterResult[]> {
    return this.http.get<TesterResult[]>(
      `${this.apiUrl}/recordings/${recordingId}/participant/${deviceId}/tester-results`,
    );
  }

  export(recordingId: string, mindDeviceId: string): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.apiUrl}/recordings/${recordingId}/participant/${mindDeviceId}/export`, null, {
      observe: 'response',
      responseType: 'blob',
    });
  }
}
